export const TARGET_LABELS = {scene:'整个场景',node:'节点',channel:'信道',nic:'网卡',flow:'业务流'}

export function sceneTargets(graph = {}) {
  const result = {scene:[{id:'',label:'整个场景'}],node:[],channel:[],nic:[],flow:[]}
  result.node = (graph.nodes || []).map(n => ({id:String(n.id),label:`${n.label || n.id} · ${n.id}`}))
  result.channel = (graph.edges || []).map(e => ({id:String(e.linkId || e.id),label:String(e.linkId || e.id)}))
  const nics = new Set()
  for (const e of graph.edges || []) for (const key of ['sourceNic','targetNic']) if (e[key]?.id) nics.add(String(e[key].id))
  result.nic = [...nics].map(id => ({id,label:id}))
  result.flow = (graph.flows || []).map(f => ({id:String(f.id),label:String(f.id)}))
  return result
}

export function eventAvailable(event,graph) {
  if (!graph?.nodes?.length) return false
  return (sceneTargets(graph)[event.target_kind] || []).some(target => target.id === event.target_id)
}

export const EVENT_TEMPLATES = [
  {id:'node-failure',name:'节点故障',kind:'node',prompt:id => `如果节点 ${id} 发生故障，请根据当前场景推演受影响实体、连接与业务流的状态。`},
  {id:'node-recovery',name:'节点恢复',kind:'node',prompt:id => `如果节点 ${id} 恢复正常，请根据当前场景推演连接与业务的状态，不假设其他故障也已恢复。`},
  {id:'channel-failure',name:'信道故障',kind:'channel',prompt:id => `如果信道 ${id} 发生故障，请根据当前场景推演相关接口、设备与业务流的状态。`},
  {id:'channel-recovery',name:'信道恢复',kind:'channel',prompt:id => `如果信道 ${id} 恢复正常，请结合当前容量、接口队列与业务需求推演实体状态。`},
  {id:'nic-failure',name:'网卡故障',kind:'nic',prompt:id => `如果网卡 ${id} 发生故障，请根据当前场景推演相关链路、设备与业务状态。`},
  {id:'nic-recovery',name:'网卡恢复',kind:'nic',prompt:id => `如果网卡 ${id} 恢复正常，请推演当前场景中的连接与业务状态，不假设信道自动恢复。`},
  {id:'flow-bandwidth',name:'业务流带宽调整',kind:'flow',prompt:id => `如果业务流 ${id} 的带宽需求调整为 200 Mbps，请根据当前路径和容量推演负载、排队与状态。`},
  {id:'video',name:'新增视频传输',kind:'node',destination:true,prompt:(id,dest) => `节点 ${id} 向节点 ${dest} 新增持续 300 秒、带宽需求 20 Mbps 的视频传输，其他业务保持不变。请推演可达路径、链路利用率与时延，不预设设备故障。`},
  {id:'bulk-transfer',name:'突发传输 10 GB',kind:'node',destination:true,prompt:(id,dest) => `节点 ${id} 向节点 ${dest} 发起 10 GB（十进制，80 Gb）数据传输，期望在 600 秒内完成，平均有效载荷需求约 133.33 Mbps，协议开销另计。请根据现有路径、剩余带宽和负载推演吞吐量、排队及时延，不将 10 GB 当作 10 Gbps。`},
  {id:'telemetry',name:'周期状态上报',kind:'node',destination:true,prompt:(id,dest) => `节点 ${id} 向节点 ${dest} 周期上报状态，每秒一次、每次 10 KB（十进制），持续 600 秒，平均新增速率 80 kbps。请推演当前场景的负载与时延，不预设故障。`}
]

export function availableTemplates(graph) {
  const targets = sceneTargets(graph || {})
  return EVENT_TEMPLATES.filter(t => targets[t.kind].length && (!t.destination || targets.node.length > 1))
}
